export default __webpack_public_path__ + "static/media/Ballroll_00062.9ad267d2.png";